<app-title-header [title]="( 'label.search_result' | translate) + ': ' + (title | translate)">
  <div class="actions-container">

    <app-global-search
      [globalSearch]="globalSearch"
      [searchData]="searchData"
      [gridUrl]="gridUrl"
      (showAllResultsEmitter)="onShowAllResults($event)"
    ></app-global-search>

    <button type="button" class="create-btn" (click)="openCreateCasePopup()">
      <div>{{ 'buttons.create_new_case' | translate }} </div>
      <i class="bi bi-chevron-down"></i>
    </button>
  </div>
</app-title-header>

<app-dynamic-table
  *ngIf="isDataTableReady"
  [tableSizeClass]="'global-search-page-table'"
  [columns]="columns"
  [rows]="rows"
  [useExternalApi]="true"
  [totalCount]="totalCount"
  [dataTableState]="dashboardDataTableState"
  [globalSearchTerm]="globalSearch"
  [datatableDisplayAllNames]="datatableDisplayAllNames"
  [filters]="filters"
  [showColumnsSettingsBtn]="true"
  [defaultColumns]="defaultColumns"
  [showSaveDatatableFilterBtn]="true"
  [gridSettingsChanged]="!!dashboardDataTableStateFromStorage"
  (dataTableStateEvent)="getDataTableState($event)"
  (linkedValueClickEvent)="getLinkedValue($event)"
  (saveDataTableSettingsEvent)="onSaveDatatableSettings($event)"
  (updateDataTableSettingsEvent)="onUpdateDatatableSettings($event)"
></app-dynamic-table>

